import React from 'react';
import { Clock, Sparkles } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { SectionHeader } from './SectionHeader';

// Best Posting Time Component
export function BestPostingTime({ bestPostingTime }) {
  return (
    <div className="bg-[hsl(var(--surface))] border border-[hsl(var(--border))] rounded-xl overflow-hidden">
      <SectionHeader 
        icon={Clock} 
        title="Best Posting Time" 
        subtitle="Optimal hours based on post performance"
        action={
          bestPostingTime?.recommendation && (
            <Badge className="bg-[#10B981]/20 text-[#10B981] text-xs">
              <Sparkles size={12} className="mr-1" />
              {bestPostingTime.recommendation}
            </Badge>
          )
        }
      />
      
      <div className="p-5">
        {bestPostingTime ? (
          <div className="space-y-5">
            {/* Time Slots Summary */}
            <div className="grid grid-cols-4 gap-3">
              {bestPostingTime.timeSlots.map((slot, idx) => (
                <div 
                  key={idx} 
                  className="rounded-lg p-3 text-center border transition-all hover:scale-105"
                  style={{ 
                    backgroundColor: `${slot.color}10`,
                    borderColor: `${slot.color}30`
                  }}
                >
                  <p className="text-xs font-medium text-white mb-1">{slot.name}</p>
                  <p className="text-[10px] text-[#6B7280] mb-2">{slot.range}</p>
                  <p className="text-lg font-bold" style={{ color: slot.color }}>{slot.posts}</p>
                  <p className="text-[9px] text-[#6B7280]">posts</p>
                  <p className="text-xs text-white mt-1">{slot.avgViews.toLocaleString()} avg views</p>
                </div>
              ))}
            </div>
            
            {/* Hourly Chart */}
            <div className="bg-[hsl(var(--surface-elevated))] rounded-lg p-4 border border-[hsl(var(--border))]">
              <p className="text-sm text-white font-medium mb-3">Hourly Performance</p>
              <ResponsiveContainer width="100%" height={160}>
                <BarChart data={bestPostingTime.hourData}>
                  <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
                  <XAxis dataKey="label" stroke="#6B7280" style={{ fontSize: '9px' }} interval={2} />
                  <YAxis stroke="#6B7280" style={{ fontSize: '9px' }} />
                  <Tooltip 
                    contentStyle={{ backgroundColor: 'hsl(var(--surface))', border: '1px solid hsl(var(--border))', borderRadius: '8px', color: '#fff', fontSize: '11px' }}
                    formatter={(value, name) => [value.toLocaleString(), name === 'avgViews' ? 'Avg Views' : 'Posts']}
                  />
                  <Bar dataKey="avgViews" fill="#3B82F6" radius={[4, 4, 0, 0]} name="Avg Views">
                    {bestPostingTime.hourData.map((entry, index) => {
                      const isBest = bestPostingTime.bestHours.some(h => h.hour === entry.hour);
                      return <Cell key={index} fill={isBest ? '#10B981' : '#3B82F6'} />;
                    })}
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        ) : (
          <div className="text-center py-8 text-[#6B7280]">
            <Clock size={32} className="mx-auto mb-2 opacity-50" />
            <p className="text-sm">No posting data available</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default BestPostingTime;
